/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Facet,
    FacetFromJSON,
    FacetFromJSONTyped,
    FacetToJSON,
} from './Facet';

/**
 * Wrapper for facets. Can be used to generate custom frontend filters.
 * @export
 * @interface FieldFacets
 */
export interface FieldFacets {
    /**
     * Id of the DAM field
     * @type {string}
     * @memberof FieldFacets
     */
    id: string;
    /**
     * Label of the DAM field
     * @type {string}
     * @memberof FieldFacets
     */
    label: string;
    /**
     * List of facets for the field
     * @type {Array<Facet>}
     * @memberof FieldFacets
     */
    facets?: Array<Facet>;
}

export function FieldFacetsFromJSON(json: any): FieldFacets {
    return FieldFacetsFromJSONTyped(json, false);
}

export function FieldFacetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldFacets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'facets': !exists(json, 'facets') ? undefined : ((json['facets'] as Array<any>).map(FacetFromJSON)),
    };
}

export function FieldFacetsToJSON(value?: FieldFacets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'facets': value.facets === undefined ? undefined : ((value.facets as Array<any>).map(FacetToJSON)),
    };
}

